import {Link} from "react-router-dom";
import React from "react";

export default function MenuNote({
                                     isRuoloSocio,
                                     isRuoloClub,
                                     isRuoloAgenzia,
                                 }) {

    return !isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia() &&
        <li className="nav-item">
            <Link className="nav-link" aria-current="page" to="/list-note">
                <div data-bs-toggle="collapse"
                     data-bs-target=".navbar-collapse.show">
                    <i className="fas fa-sticky-note"/> Note
                </div>
            </Link>
        </li>
}